import { slicedToArray as _slicedToArray } from '../../../../_virtual/_rollupPluginBabelHelpers.js';

function getFloatingPosition(dir, position) {
  if (dir === 'rtl' && (position.includes('right') || position.includes('left'))) {
    var _position$split = position.split('-'),
      _position$split2 = _slicedToArray(_position$split, 2),
      side = _position$split2[0],
      placement = _position$split2[1];
    var flippedPosition = side === 'right' ? 'left' : 'right';
    return placement === undefined ? flippedPosition : "".concat(flippedPosition, "-").concat(placement);
  }
  return position;
}

export { getFloatingPosition };
//# sourceMappingURL=get-floating-position.js.map
